<!-- Knopfleiste der Grafik-/KI-Ansicht.
     Zweimal auf der Seite: oben mit Überschrift und seitenweiter Wirkung, und kompakt an
     jeder Zeilenüberschrift mit Wirkung nur auf deren Karten. -->
<div class="graphic-toolbar"
  [class.graphic-toolbar--global]="!kompakt"
  [class.graphic-toolbar--kompakt]="kompakt">

  @if (!kompakt) {
    <div class="graphic-toolbar__kopf">
      <h3 class="graphic-toolbar__title">{{ title }}</h3>
      <!-- Sagt ausdrücklich, dass diese Leiste für alle Zeilen gilt: die gleichen
           Knöpfe stehen an jeder Zeilenüberschrift und wirken dort nur lokal. -->
      <span class="graphic-toolbar__umfang"
        title="Die Knöpfe an einer Zeilenüberschrift wirken nur auf die Karten dieser Zeile.">
        <mat-icon>public</mat-icon>
        <span>gilt für <strong>alle Zeilen</strong> dieses Reiters</span>
      </span>
      <!-- Ausnahme vom Satz darüber: der KI-Knopf oben nimmt nur Zeilen mit angehaktem
           Symbol mit (KiGrafikService.baueAnfrage, nurAngehakteZeilen). -->
      @if (zeigtKiHinweis) {
        <span class="graphic-toolbar__umfang graphic-toolbar__umfang--ki"
          title="Zeilen ohne angehaktes Symbol gehen gar nicht in die KI-Anfrage – auch nicht ihre Temperaturen und Windwerte.">
          <mat-icon>check_box</mat-icon>
          <span>KI-Texte nur aus Zeilen mit <strong>angehaktem Symbol</strong> (gelbes Kästchen)</span>
        </span>
      }
    </div>
  }

  <!-- Zoom der Karten: wirkt nur auf die Grafiken, unabhängig vom Browser-Zoom -->
  @if (showZoom) {
    <app-karten-zoom></app-karten-zoom>
  }

  <div class="graphic-toolbar__actions">
    @for (action of actions; track action.label) {
      <button type="button"
        class="dmx-pill-button"
        [class.dmx-pill-button--kompakt]="kompakt"
        [class.dmx-pill-button--ki]="action.ki"
        [attr.title]="knopfTitel(action)"
        (click)="onAction(action)">
        @if (action.ai) {
          <span class="dmx-pill-button__ai">AI</span>
        } @else if (action.icon) {
          <mat-icon>{{ action.icon }}</mat-icon>
        }
        <span>{{ action.label }}</span>
      </button>
      <!-- Nur im Reiter "Nacht" (Leiste oben): Schalter, ob "KI-Texte erzeugen" zusätzlich
           eine Schlagzeile aus den Nacht-Daten erzeugt – wie in "Heute", in dieselbe Box.
           Standard aus; Zustand nur in der Sitzung (SchlagzeileSchalterService). -->
      @if (istKiAktion(action) && zeigtSchlagzeilenSchalter) {
        <button type="button"
          class="dmx-pill-button dmx-pill-button--schalter"
          role="switch"
          [class.dmx-pill-button--an]="schlagzeileAn"
          [attr.aria-checked]="schlagzeileAn"
          [attr.title]="schlagzeileTitel"
          (click)="onSchlagzeileToggle()">
          <mat-icon>{{ schlagzeileAn ? 'toggle_on' : 'toggle_off' }}</mat-icon>
          <span>Schlagzeile erzeugen</span>
        </button>
      }
      <!-- Fortschritt der KI-Anfrage dieses Knopfes: Ring, Sekunden, Phase, am Ende Lampe.
           Jede Leiste hat ihren eigenen Schlüssel, die Anzeige steht also nur neben dem
           Knopf, der gedrückt wurde. -->
      @if (istKiAktion(action)) {
        <app-ki-lauf-anzeige [schluessel]="laufSchluessel"></app-ki-lauf-anzeige>
      }
    }
  </div>
</div>

<!-- Rückmeldung des KI-Knopfes dieser Leiste, also die Antwort für den ganzen Reiter.
     Der [umfang] ist Pflicht: ohne ihn sucht die Box eine Antwort ohne Schlüssel und
     bleibt für immer leer. Die Zeilen zeigen ihre eigene Antwort selbst, gleich unter
     ihrer Überschrift. -->
@if (zeigtErgebnis) {
  <app-ki-ergebnis-box [umfang]="umfang"></app-ki-ergebnis-box>
}

<!-- Was der Knopf "MSWR-MOS laden" dieser Leiste geladen hat (Quellen und Stand der Daten) –
     nur bei der Leiste oben; die Zeilen zeigen ihren eigenen Kasten unter ihrer Überschrift. -->
@if (!kompakt) {
  <app-lade-quellen-box [umfang]="umfang"></app-lade-quellen-box>
}
